import React from 'react';
import { Link } from 'react-router-dom';
import Header from './../../../component/common/AdminHeader';

import 'react-bootstrap-typeahead/css/Typeahead.css';

import Loader from './../../../component/common/Loader';

import CONSTANT from './../../../constant';
import { onChange, validateForm } from './../../../utils';
import { addGradeList } from './../../../actions/MasterAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            name: { name: 'name', value: '', error: '', isRequired: true },
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.home;


    }

    render() {
        const { name, } = this.state;
        const { showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob'>
                            <div className="row">
                                <div className="col-md-12 my-3">
                                    <h1 className="page-title">Grade detail</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <form onSubmit={this.onSubmit}>
                                                <div className="row">


                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Grade</label>
                                                            <input
                                                                type="text"
                                                                className={name.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder="Name of the Grade"
                                                                name={name.name}
                                                                value={name.value}
                                                                onChange={this.onChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <Link to={CONSTANT.component.adminGradeList.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                                    </div>
                                                    <div className="col-md-6">
                                                        &nbsp;
                                                    </div>
                                                    <div className="col-md-3">
                                                        <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onChange = (e: any) => {

        onChange(this, e.target.name, e.target.value);
    }


    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const st = this.state;
            const model = {
                name: st.name.value,
            }

            addGradeList(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res) {
                    if (res.status === CONSTANT.static.apiStatus.success) {
                        alert('record added successfully');
                        this.props.history.push(CONSTANT.component.adminGradeList.url);
                    } else {
                        alert(res.error);
                    }
                }

            });
        }
    }
}

export default ComponentName;